import React, { useEffect, useState } from "react";
import BookItem from "../items/BookItem";
import getBooks from "../api/get/getBooks";
import Spinner from "../components/Spinner";

import { useSystemTheme } from "../utils/useSystemTheme";

const SongsSection = React.memo(({ selectedCategory, onPlay }) => {
    const [bestSellers, setBestSellers] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [loading, setLoading] = useState(true);
    const theme = useSystemTheme();

    useEffect(() => {
        const fetchSongs = async () => {
            setLoading(true);

            const tryFetch = async (retries = 5) => {
                const token = localStorage.getItem("access_token_esti");
                if (!token && retries > 0) {
                    setTimeout(() => tryFetch(retries - 1), 300);
                    return;
                }

                try {
                    const books = await getBooks("songAudio");
                    setBestSellers(books || []);
                } catch (error) {
                    console.error("Жырларды жүктеу қатесі:", error);
                } finally {
                    setLoading(false);
                }
            };

            tryFetch();
        };

        fetchSongs();
    }, []);

    const filteredBooks = selectedCategory
        ? bestSellers.filter((book) => book.genre === selectedCategory)
        : bestSellers;

    // Тақырыпқа байланысты мәтін түсі
    // const textColor = theme === "dark" ? "text-gray-100" : "text-gray-900";
    const subTextColor = theme === "dark" ? "text-gray-400" : "text-gray-500";

    return (
        <div className="px-4">
            {loading ? (
                <Spinner />
            ) : filteredBooks.length > 0 ? (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {filteredBooks.slice(0, showAll ? filteredBooks.length : 8).map((book) => (
                        <BookItem
                            key={book.id}
                            id={book.id}
                            image={book.imageUrl}
                            title={book.title}
                            onPlay={onPlay}
                        />
                    ))}
                </div>
            ) : (
                <p className={`text-sm ${subTextColor}`}>
                    {selectedCategory
                        ? `"${selectedCategory}" жанрына сай жырлар табылмады.`
                        : "Аудиокітаптар жоқ."}
                </p>
            )}

            {filteredBooks.length > 8 && (
                <div className="flex justify-center mt-4">
                    <button
                        onClick={() => setShowAll(!showAll)}
                        className="px-4 py-2 text-white rounded-lg"
                        style={{
                            backgroundColor: "var(--app-color)",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        {showAll ? "Жасыру" : "Көбірек көрсету"}
                    </button>
                </div>
            )}
        </div>
    );
});

export default SongsSection;